import { useContext } from "react";
import { Navigate } from "react-router-dom";

import PageLayout from "@/components/layouts/page/PageLayout";
import RequestFromBrand from "../components";
import { ROUTES } from "@/helpers/routes/routePaths";
import { GlobalContext } from "@/helpers/contexts/contexts";

type BrandRequestGateBrand = {
  is_brand_request?: boolean;
};

function RequestFromBrandPage() {
  const { selectedBrand } = useContext(GlobalContext);
  const brand = selectedBrand as BrandRequestGateBrand | null | undefined;

  if (!brand?.is_brand_request) {
    return <Navigate to={ROUTES.ROOT} replace />;
  }

  return (
    <>
      <PageLayout>
        <RequestFromBrand />
      </PageLayout>
    </>
  );
}

export default RequestFromBrandPage;
